import Button from "@material-ui/core/Button";
import Collapse from "@material-ui/core/Collapse";
import Divider from "@material-ui/core/Divider";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { ZoomOutMap } from "@material-ui/icons";
import AssignmentIcon from "@material-ui/icons/Assignment";
import BusinessIcon from "@material-ui/icons/Business";
import CheckIcon from "@material-ui/icons/Check";
import {
  default as CloseIcon,
  default as CloseOutlinedIcon,
} from "@material-ui/icons/Close";
import PersonOutlineIcon from "@material-ui/icons/PersonOutline";
import ImagePreviewDialog from "components/ImagePreviewDialog";
import React from "react";
import StatusChip from "./StatusChip";

const useStyles = makeStyles((theme) => ({
  wrapper: {
    marginTop: theme.spacing(2),
  },
  paper: {
    padding: theme.spacing(3),
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: theme.spacing(1),
  },
  headerLeft: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
  },
  avatar: {
    width: 56,
    height: 56,
    backgroundColor: theme.palette.grey[300],
  },
  metaRow: {
    display: "flex",
    gap: theme.spacing(3),
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(2),
    flexWrap: "wrap",
  },
  sectionPaper: {
    padding: theme.spacing(2),
    height: "100%",
  },
  sectionTitle: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    fontWeight: 700,
    marginBottom: theme.spacing(2),
  },
  infoRow: {
    display: "flex",
    justifyContent: "space-between",
    padding: theme.spacing(0.75, 0),
  },
  infoLabel: {
    color: theme.palette.text.secondary,
  },
  infoValue: {
    fontWeight: 600,
  },
  documentRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(1, 0),
  },
  documentLeft: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  documentThumb: {
    width: 76,
    height: 76,
    borderRadius: 8,
    objectFit: "cover",
    backgroundColor: theme.palette.grey[200],
  },
  actions: {
    display: "flex",
    gap: theme.spacing(2),
    marginTop: theme.spacing(3),
  },
  approveButton: {
    flex: 1,
    borderColor: theme.palette.success.main,
    color: theme.palette.success.main,
    "&:hover": {
      backgroundColor: theme.palette.success.light,
      color: theme.palette.error.contrastText,
    },
  },
  rejectButton: {
    flex: 1,
    borderColor: theme.palette.error.main,
    color: theme.palette.error.main,
    "&:hover": {
      backgroundColor: theme.palette.error.light,
      color: theme.palette.error.contrastText,
    },
  },
}));

// پنل جزئیات درخواست که به‌صورت inline زیر جدول باز می‌شود (به‌جای مودال)
export default function RequestDetailsPanel({
  request,
  files,
  onClose,
  onApprove,
  onReject,
  status,
}) {
  const classes = useStyles();

  const [preview, setPreview] = React.useState({
    open: false,
    image: "",
    title: "",
  });

  const openPreview = (image, title) => {
    setPreview({
      open: true,
      image,
      title,
    });
  };

  const closePreview = () => {
    setPreview({
      open: false,
      image: "",
      title: "",
    });
  };

  return (
    <Collapse in={Boolean(request)} className={classes.wrapper} unmountOnExit>
      {request && (
        <Paper variant="outlined" className={classes.paper}>
          <div className={classes.header}>
            <div className={classes.headerLeft}>
              <Typography variant="h6">
                {request.firstname} {request.lastname}
              </Typography>
              <StatusChip status={status} />
            </div>
            <div className={classes.headerLeft}>
              {/* <Avatar className={classes.avatar}>
                <PersonOutlineIcon />
              </Avatar> */}
              <IconButton onClick={onClose} size="small" title="بستن جزئیات">
                <CloseIcon />
              </IconButton>
            </div>
          </div>

          <div className={classes.metaRow}>
            <Typography variant="body2">کد ملی: {request.ssn}</Typography>
            <Typography variant="body2">
              تاریخ درخواست:{" "}
              {new Date(request.updated_at).toLocaleTimeString("fa-Ir")} -{" "}
              {new Date(request.updated_at).toLocaleDateString("fa-Ir")}
            </Typography>
            {/* <Typography variant="body2">{request.tel}</Typography> */}
          </div>

          <Grid container spacing={2}>
            {/* اطلاعات شخصی */}
            <Grid item xs={12} md={4}>
              <Paper variant="outlined" className={classes.sectionPaper}>
                <Typography className={classes.sectionTitle}>
                  <PersonOutlineIcon fontSize="small" color="primary" />
                  اطلاعات شخصی
                </Typography>
                <div className={classes.infoRow}>
                  <Typography variant="body2" className={classes.infoLabel}>
                    نام:
                  </Typography>
                  <Typography variant="body2" className={classes.infoValue}>
                    {request.firstname}
                  </Typography>
                </div>
                <div className={classes.infoRow}>
                  <Typography variant="body2" className={classes.infoLabel}>
                    نام خانوادگی:
                  </Typography>
                  <Typography variant="body2" className={classes.infoValue}>
                    {request.lastname}
                  </Typography>
                </div>
                <div className={classes.infoRow}>
                  <Typography variant="body2" className={classes.infoLabel}>
                    کد ملی:
                  </Typography>
                  <Typography variant="body2" className={classes.infoValue}>
                    {request.ssn}
                  </Typography>
                </div>
              </Paper>
            </Grid>

            {/* اطلاعات شرکت و دفتر */}
            <Grid item xs={12} md={4}>
              <Paper variant="outlined" className={classes.sectionPaper}>
                <Typography className={classes.sectionTitle}>
                  <BusinessIcon fontSize="small" color="primary" />
                  اطلاعات شرکت و دفتر
                </Typography>
                <div className={classes.infoRow}>
                  <Typography variant="body2" className={classes.infoLabel}>
                    عنوان شغل:
                  </Typography>
                  <Typography variant="body2" className={classes.infoValue}>
                    {request.get_type.name}
                  </Typography>
                </div>
                <div className={classes.infoRow}>
                  <Typography variant="body2" className={classes.infoLabel}>
                    نام شرکت:
                  </Typography>
                  <Typography variant="body2" className={classes.infoValue}>
                    {request.name}
                  </Typography>
                </div>
                <div className={classes.infoRow}>
                  <Typography variant="body2" className={classes.infoLabel}>
                    شناسه ملی:
                  </Typography>
                  <Typography variant="body2" className={classes.infoValue}>
                    {request.nid}
                  </Typography>
                </div>
                <div className={classes.infoRow}>
                  <Typography variant="body2" className={classes.infoLabel}>
                    تلفن ثابت:
                  </Typography>
                  <Typography variant="body2" className={classes.infoValue}>
                    {request.tel}
                  </Typography>
                </div>
                <div className={classes.infoRow}>
                  <Typography variant="body2" className={classes.infoLabel}>
                    شهر:
                  </Typography>
                  <Typography variant="body2" className={classes.infoValue}>
                    {request.city.name}
                  </Typography>
                </div>
                <div className={classes.infoRow}>
                  <Typography variant="body2" className={classes.infoLabel}>
                    آدرس دفتر:
                  </Typography>
                  <Typography
                    variant="body2"
                    className={classes.infoValue}
                    align="left"
                  >
                    {request.address}
                  </Typography>
                </div>
              </Paper>
            </Grid>

            {/* مدارک هویتی */}
            <Grid item xs={12} md={4}>
              <Paper variant="outlined" className={classes.sectionPaper}>
                <Typography className={classes.sectionTitle}>
                  <AssignmentIcon fontSize="small" color="primary" />
                  مدارک هویتی
                </Typography>

                <div className={classes.documentRow}>
                  <div className={classes.documentLeft}>
                    <IconButton
                      onClick={() =>
                        openPreview(
                          `https://api.onlinebar.app/uploads/${files[0].url}`,
                          "تصویر کارت ملی"
                        )
                      }
                      size="small"
                      title="دانلود تصویر کارت ملی"
                    >
                      <ZoomOutMap fontSize="small" color="primary" />
                    </IconButton>
                    <Typography variant="body2">تصویر رو کارت ملی</Typography>
                  </div>
                  {files[0].url ? (
                    <img
                      src={`https://api.onlinebar.app/uploads/${files[0].url}`}
                      alt="کارت ملی"
                      className={classes.documentThumb}
                      onClick={() =>
                        openPreview(
                          `https://api.onlinebar.app/uploads/${files[0].url}`,
                          "تصویر کارت ملی"
                        )
                      }
                      style={{
                        cursor: "pointer",
                      }}
                    />
                  ) : (
                    <div className={classes.documentThumb} />
                  )}
                </div>

                <Divider />

                <div className={classes.documentRow}>
                  <div className={classes.documentLeft}>
                    <IconButton
                      onClick={() =>
                        openPreview(
                          `https://api.onlinebar.app/uploads/${files[1].url}`,
                          "تصویر سلفی"
                        )
                      }
                      size="small"
                      title="دانلود تصویر سلفی"
                    >
                      <ZoomOutMap fontSize="small" color="primary" />
                    </IconButton>
                    <Typography variant="body2">تصویر سلفی</Typography>
                  </div>
                  {files[1]?.url ? (
                    <img
                      // src={files[1]?.url}
                      src={`https://api.onlinebar.app/uploads/${files[1].url}`}
                      alt="سلفی"
                      className={classes.documentThumb}
                      onClick={() =>
                        openPreview(
                          `https://api.onlinebar.app/uploads/${files[1].url}`,
                          "تصویر سلفی"
                        )
                      }
                      style={{
                        cursor: "pointer",
                      }}
                    />
                  ) : (
                    <div className={classes.documentThumb} />
                  )}
                </div>
              </Paper>
            </Grid>
          </Grid>

          <div className={classes.actions}>
            <Button
              variant="outlined"
              className={classes.approveButton}
              startIcon={<CheckIcon style={{ marginLeft: 6 }} />}
              onClick={() => onApprove(request.id)}
            >
              تایید درخواست
            </Button>
            <Button
              variant="outlined"
              className={classes.rejectButton}
              startIcon={<CloseOutlinedIcon style={{ marginLeft: 6 }} />}
              onClick={() => onReject(request.id)}
            >
              رد درخواست
            </Button>
          </div>
        </Paper>
      )}

      <ImagePreviewDialog
        open={preview.open}
        image={preview.image}
        title={preview.title}
        onClose={closePreview}
      />
    </Collapse>
  );
}
